import { useEffect, useMemo } from "react";
import LorsHero from "@/components/landing/lors/LorsHero";
import LorsTestimonials from "@/components/landing/lors/LorsTestimonials";
import LorsAbout from "@/components/landing/lors/LorsAbout";
import LorsRegistration from "@/components/landing/lors/LorsRegistration";
import LorsFooter from "@/components/landing/lors/LorsFooter";
import LorsStickyCta from "@/components/landing/lors/LorsStickyCta";
import { getMay29Copy } from "@/components/landing/lors/translationsMay29";
import { captureUtmsFromUrl } from "@/components/landing/lors/utmStorage";

const REDIRECT_TO = "/may-29-2026/ty";

const May292026 = () => {
  useEffect(() => {
    captureUtmsFromUrl();
    const prev = document.documentElement.lang;
    document.documentElement.lang = "en";
    return () => {
      document.documentElement.lang = prev;
    };
  }, []);

  const copy = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return getMay29Copy(params.get("h"));
  }, []);

  return (
    <main className="lors-theme">
      <LorsHero
        copy={copy}
        redirectTo={REDIRECT_TO}
        headlineSizeClass="text-4xl md:text-[64px] leading-tight md:leading-[80px] font-bold"
        bulletsMontserrat
        formKey="may29"
      />
      <LorsTestimonials copy={copy} lang="en" />
      <LorsAbout copy={copy} />
      <LorsRegistration copy={copy} />
      <LorsFooter copy={copy} />
      <LorsStickyCta copy={copy} />
    </main>
  );
};

export default May292026;
